import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Button, Card, Stack } from "@salesapp/ui";
import { api } from "../lib/api";
import "./crm/crm.css";

export function QuoteAcceptPage() {
  const { token = "" } = useParams();
  const [quote, setQuote] = useState<{
    quote_number: string;
    company_name: string;
    total: string | null;
    currency: string | null;
    quote_status: string;
    html?: string | null;
  } | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  useEffect(() => {
    void api.get<typeof quote>(`/public/quotes/${encodeURIComponent(token)}`).then(setQuote).catch((err) => {
      setError(err instanceof Error ? err.message : "This quote link is not valid.");
    });
  }, [token]);

  return (
    <main className="app-shell-main">
      <Card>
        <Stack gap={4}>
          <h1 className="home-title">Accept quote</h1>
          {error && <p className="crm-error">{error}</p>}
          {quote && (
            <>
              {quote.html ? (
                <div className="crm-document-sheet" dangerouslySetInnerHTML={{ __html: quote.html }} />
              ) : (
                <>
                  <p>{quote.company_name} — {quote.quote_number}</p>
                </>
              )}
              <p>{quote.total ? `${quote.total} ${quote.currency ?? ""}`.trim() : "Amount on file"}</p>
              {done || quote.quote_status === "accepted" ? (
                <p>This quote is accepted. The sales team has been notified.</p>
              ) : (
                <Button
                  onClick={() => {
                    void api.post(`/public/quotes/${encodeURIComponent(token)}/accept`, {}).then(() => setDone(true)).catch((err) => {
                      setError(err instanceof Error ? err.message : "The quote could not be accepted.");
                    });
                  }}
                >
                  Accept quote
                </Button>
              )}
            </>
          )}
        </Stack>
      </Card>
    </main>
  );
}

export function UnsubscribePage() {
  const { token = "" } = useParams();
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  return (
    <main className="app-shell-main">
      <Card>
        <Stack gap={4}>
          <h1 className="home-title">Unsubscribe from marketing</h1>
          <p>This turns off marketing email for this contact. Transactional messages about quotes and orders can still be sent.</p>
          {error && <p className="crm-error">{error}</p>}
          {done ? (
            <p>You are unsubscribed. Marketing mail will stop for this address.</p>
          ) : (
            <Button
              onClick={() => {
                void api.post(`/public/marketing/unsubscribe/${encodeURIComponent(token)}`, {}).then(() => setDone(true)).catch((err) => {
                  setError(err instanceof Error ? err.message : "The unsubscribe link is not valid.");
                });
              }}
            >
              Confirm unsubscribe
            </Button>
          )}
        </Stack>
      </Card>
    </main>
  );
}
